import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders, HttpErrorResponse} from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class AuthService {

  loginUrl: string; 
  public passwordChangable = true;

  constructor(private http: HttpClient ) {}

  loggedIn(logindata): Observable<any> {
    return this.http.post(environment.baseURL + 'login', logindata).catch(this.errorHandler)
  }

  getAdminData() {
    const headers = new HttpHeaders({'Content-Type': 'application/json', 'Authorization':  'Bearer ' + localStorage.getItem('token')});
    const options = {headers: headers};
    return this.http.get(environment.baseURL + 'users/profile', options);
  }

  Updatepassword(userpassword: any): Observable<any> {
    const headers = new HttpHeaders({'Content-Type': 'application/json', 'Authorization':  'Bearer ' + localStorage.getItem('token')});
    const options = {headers: headers};
    return this.http.post(environment.baseURL + 'users/changePassword', userpassword, options);
  }

  
  Forgetpassword(Email: any): Observable<any> {
    const headers = new HttpHeaders({'Content-Type': 'application/json', 'token': 'ca206204-eb0c-4c45-8fd0-47f1af3f771b'});
    const options = {headers: headers};
    return this.http.post(environment.baseURL + 'LocalSupplier/ForgotPassword', Email, options);
  }

  
  errorHandler(error: HttpErrorResponse) {
    return Observable.throw(error || "Server Error");
  }

  logout(): void {
  localStorage.removeItem('')
  localStorage.removeItem('token')
  localStorage.removeItem('userDetails')
  localStorage.clear();
  }

}
